import {isEmpty} from 'lodash';
import {LIBRARY_NAME} from 'src/js/common/constants';
import LogUtils from 'src/js/common/utils/log_utils';
import {getAccessTokenValue} from 'src/js/common/utils/security_utils';
import {I18N_REDUCER_STATE_ID} from 'src/js/containers/i18n/i18n_constants';
import * as at from 'src/js/containers/login/login_action_types';
import {LOGIN_REDUCER_STATE_ID} from 'src/js/containers/login/login_constants';
import {AppStore} from 'src/js/store';

import {FetcherUtils} from '../common/utils/fetcher_utils';

const logger = LogUtils.getLogger('AuthorizationFetcher', LIBRARY_NAME);

const XSRF_TOKEN = 'XSRF-TOKEN';
const X_XSRF_TOKEN_HEADER = 'X-XSRF-TOKEN';
const AUTHORIZATION_HEADER = 'Authorization';
const ACCEPT_LANGUAGE = 'Accept-Language';

/** @deprecated */
const AuthorizationFetcher = {
  store: {},

  getUserRights(requestUrl, noAuth = false) {
    if (!requestUrl) {
      logger.error(`Missing request endpoint, requestUrl: ${requestUrl}`);
    }
    return AuthorizationFetcher.interceptedFetch(requestUrl, {method: 'get'}, {'Content-Type': 'application/json'}, noAuth)
      .then((response) => {
        let result;
        if (response.type === 'opaque' || response.ok) {
          result = response.status === FetcherUtils.HTTP_STATUS_NO_CONTENT ? {} : response.json();
        } else {
          FetcherUtils.errorHandler(response);
        }
        return result;
      })
      .catch((response) => {
        FetcherUtils.errorHandler(response);
      });
  },

  initStore(store: AppStore) {
    this.store = store;
  },

  interceptedFetch(requestUrl, opts: RequestInit, headersObject = {}, noAuth = false) {
    let newOpts: RequestInit = opts;
    let accessToken;
    let newHeaders = headersObject;

    if (this.store && this.store.getState) {
      const state = this.store.getState();
      newHeaders = {
        ...newHeaders,
        [ACCEPT_LANGUAGE]: state[I18N_REDUCER_STATE_ID].currentLocale,
      };

      // reset user idle time
      this.store.dispatch({
        type: at.RESET_IDLE_TIME,
        payload: true,
        stateId: LOGIN_REDUCER_STATE_ID,
      });
    }

    if (!noAuth) {
      accessToken = getAccessTokenValue();
      if (!isEmpty(accessToken)) {
        newHeaders = {...newHeaders, [AUTHORIZATION_HEADER]: accessToken};
      }
    }
    const csrfToken = FetcherUtils.getCookieValue(XSRF_TOKEN);
    if (!isEmpty(csrfToken)) {
      newHeaders = {...newHeaders, [X_XSRF_TOKEN_HEADER]: csrfToken};
    }
    if (!isEmpty(newHeaders)) {
      newOpts = {
        ...newOpts,
        headers: new Headers(newHeaders),
        credentials: 'same-origin',
      };
    }
    return fetch(requestUrl, newOpts);
  },
};

export default AuthorizationFetcher;
